import React from 'react'
import Chart from "react-apexcharts";
import { useOutletContext } from 'react-router-dom';
import { CHART_TITLE_STYLE } from "../HelperFunction/helperFunction";

function LineChartOptimizer({fulldataset1,fulldataset2,range,endDate}) {
  const { theme } = useOutletContext();
  const isDark = theme !== 'light';
  const today1 = new Date();
  const currentYear = today1.getFullYear();
  const currentMonth = today1.getMonth();
 
   let unblockeddate;
   if (currentMonth >= 3) {
    unblockeddate = new Date(currentYear, currentMonth, 1);
  } else {
    const currentmonth15thdate = new Date(today1.getFullYear(), today1.getMonth(), 1);
    const isBefore15th = new Date() < currentmonth15thdate;
     unblockeddate = isBefore15th?new Date(today1.getFullYear(), today1.getMonth()-3, 1):new Date(today1.getFullYear(), today1.getMonth()-3, 1);
    }
  
  //const MonthBeforeUnlockMonth = `${unblockeddate.getFullYear()}-${String(unblockeddate.getMonth() + 1).padStart(2, "0")}`;
  //const MonthBeforeUnlockMonthreverse = MonthBeforeUnlockMonth.split("-").reverse().join("-");
  const MonthBeforeUnlockMonth = endDate;

    const predictedsalesvolumebasescenarioselectedmonths =
    fulldataset2?.plot1?.reduce((total, item) => {
      const [year, month] = item?.month_year?.split('-').map(Number);

      // Only add predicted sales if the date is within the target range
      if (item.month_year > MonthBeforeUnlockMonth) {
        return total + (Number(item?.predicted_sales) || 0);
      }

      return total;
    }, 0) / 1000;
    const optimizedsalesvolumebasescenarioselectedmonths =
    fulldataset1?.reduce((total, item) => {
      const [year, month] = item?.month_year?.split('-').map(Number);

      // Only add predicted sales if the date is within the target range
      if (item.month_year > MonthBeforeUnlockMonth) {
        return total + (Number(item?.optimized_spends) || 0);
      }

      return total;
    }, 0) / 1000;
  
    // Filter the data to include only entries starting from the next month
    // const filteredDataplot1 = fulldataset1?.plot1.map(item => {
    //   const [year, month] = item?.month_year.split('-').map(Number); // Split "YYYY-MM" into year and month

    //   // Check if the month-year should have predicted_sales as null
    //   if (year > nextYear || (year === nextYear && month >= nextMonth)) {
    //     return item; 
    //   } else {
    //     return { ...item, predicted_sales: null };
    //   }
    // });
    // const filteredDataplot2 = fulldataset1?.plot7.map(item => {
    //     const [year, month] = item?.month_year && item.month_year !== "0" && item.month_year.includes('-')
    //     ? item.month_year.split('-').map(Number)
    //     : [null, null]; 
  

    //     if (year > nextYear || (year === nextYear && month >= nextMonth)) {
    //       return item;
    //     } else {
    //       return { ...item, sales_value: null }; 
    //     }
    //   });
    //  const predictedsalesvolumebasescenarioselectedmonths=
    //     fulldataset2?.plot1?.reduce((total, item) => {
    //       const [year, month] = item?.month_year?.split('-').map(Number);
    //       // Only add if the date is within the target fiscal year
    //       if (year > nextYear || (year === nextYear && month >= nextMonth)) {
    //         return total + (Number(item?.predicted_sales) || 0);
    //       }
  
    //       return total;
    //     }, 0) /1000 
    //     const predictedsalesvaluebasescenarioselectedmonths=
    //     fulldataset2?.plot7?.reduce((total, item) => {
    //       const [year, month] = item?.month_year?.split('-').map(Number);
    //       // Only add if the date is within the target fiscal year
    //       if (year > nextYear || (year === nextYear && month >= nextMonth)) {
    //         return total + (Number(item?.total_sales_value) || 0);
    //       }
  
    //       return total;
    //     }, 0) /1000 
const options= 
{
    chart: {
      id: `Download-Sales`,
      type: "line",
      background: 'transparent',      toolbar: {
        show: true,
      },
    },
    grid: {
      show: false,
    },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
    },
    legend: {      fontSize: "12px",
    },
    title: {
      text: 'Sales Volume',
      align: 'center',
      style: CHART_TITLE_STYLE,
    },
    plotOptions: {},
    colors: ['#27ae60', '#f4d03f', '#1e81b0'],
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "13px",
      },
      formatter: function (val) {
        return val ? Number(Number(val).toFixed(2))?.toLocaleString("en-IN") : "";
      },
    },
    xaxis: {
      categories: fulldataset2?.plot1?.map((item) =>
        item?.month_year?.trim()
      ),
      title: {
        text: 'Month-Year',
        style: {
          fontWeight: 600,
          fontSize: "12px",
        },
      },
      labels: {
        style: {
          fontWeight: 500,
          fontSize: "12px",        },
        formatter: function (val) {
          return val;
        },
      },
      axisBorder: { color: isDark ? '#495057' : '#dee2e6' },
    },
    yaxis: [
      {
        seriesName: 'Scenario Predicted Sales',
        opposite: false,
        min: 0, // Ensures the Y-axis starts from 0
        labels: {
          style: {
            fontWeight: 500,          },
          formatter: function (val) {
            return Number(val)?.toFixed(2);
          },
        },
        axisBorder: {
          show: true, // Ensures Y-axis line is visible
          color: isDark ? '#495057' : '#dee2e6',
        },
        title: {
          text: "Sales Volume (Tonnes)",
          showAlways: true,
          floating: false,
          style: {
            fontWeight: 600,
            fontSize: "12px",
          },
        },
      },
      // Uncomment other y-axis configurations if needed
    ],
  }
  const categories=fulldataset2?.plot1?.map((item) =>
    item?.month_year
  )
  const optimizedSalesData = categories?.map((category) => {
    const matchingItem = fulldataset1?.find(
      (item) => item.month_year === category
    );
    return matchingItem ? (matchingItem?.optimized_spends/1000)?.toFixed(2) : null;
  });
 
const plotdata=
[
    {
      name: "Scenario Predicted Sales Volume", data: 
      fulldataset2?.plot1?.map((item, index) => 
       item.predicted_sales!==null?(item?.predicted_sales/1000)?.toFixed(2):null
      )
    },       
    {
      name: "Optimized Sales Volume", data: 
      optimizedSalesData  

    },      
  ]
  return (
    <>
      <div className="rr-chart-period">
        <small>Time Period: {range}</small>
      </div>
      <div className="rr-chart-summary">
        <div className="rr-chart-summary-line">
          Total Planned Predicted Sales Volume:{" "}
          <span>
            {Number(predictedsalesvolumebasescenarioselectedmonths.toFixed(2))?.toLocaleString("en-IN")}{" "}
            Tonnes
          </span>
        </div>
        <div className="rr-chart-summary-line">
          Total Optimized Sales Volume:{" "}
          <span>
            {Number(optimizedsalesvolumebasescenarioselectedmonths.toFixed(2))?.toLocaleString("en-IN")}{" "}
            Tonnes
          </span>
        </div>
      </div>
      <div className="my-2">
        <Chart
          className="rr-apex"
          align="center"
          options={options}
          series={plotdata}
          type="line"
          height={340}
          width={'100%'}
        />
      </div>
    </>
  )
}

export default LineChartOptimizer